import _asyncToGenerator from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { useEffect, useRef, useState } from 'react';
import useSWR from 'swr';
import { API_DISCUSSIONS_TOKEN_REQUEST } from '@poplar/constants/routes';
import { fetchJson } from '@yoweb/utils/fetchJson';
import { toErrorObject } from '@yoweb/utils/error';
import { useUser } from './useUser';
var ablyClient;
var MAX_FAILED_TOKEN_REFRESHES = 3;
export var useAbly = function useAbly() {
  var user = useUser(); // Get and cache necessary token request for Ably client

  var _useSWR = useSWR(API_DISCUSSIONS_TOKEN_REQUEST, fetchJson, {
    revalidateIfStale: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false
  }),
      tokenResponse = _useSWR.data,
      error = _useSWR.error;

  var _useState = useState(error),
      stateError = _useState[0],
      setStateError = _useState[1];

  var _useState2 = useState(ablyClient),
      ably = _useState2[0],
      setAbly = _useState2[1];

  var tokenFetchErrorCountRef = useRef(0);
  useEffect(function () {
    if (tokenResponse && !ablyClient && user.isAuthenticated) {
      void import('ably').then(function (_ref) {
        var Realtime = _ref.Realtime;
        ablyClient = new Realtime({
          token: tokenResponse.token,
          useTokenAuth: true,

          /**
           * A function which is called when a new token is required.
           * The role of the callback is to either generate a signed TokenRequest
           * which may then be submitted automatically by the library to the Ably REST API requestToken;
           * or to provide a valid token in as a TokenDetails object.
           */
          authCallback: function authCallback(_tokenParams, callback) {
            return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
              var newTokenRes;
              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      if (!(tokenFetchErrorCountRef.current >= MAX_FAILED_TOKEN_REFRESHES)) {
                        _context.next = 2;
                        break;
                      }

                      return _context.abrupt("return");

                    case 2:
                      _context.prev = 2;
                      _context.next = 5;
                      return fetchJson(API_DISCUSSIONS_TOKEN_REQUEST);

                    case 5:
                      newTokenRes = _context.sent;
                      callback(null, newTokenRes.token);
                      tokenFetchErrorCountRef.current = 0; // eslint-disable-next-line no-catch-all/no-catch-all

                      _context.next = 16;
                      break;

                    case 10:
                      _context.prev = 10;
                      _context.t0 = _context["catch"](2);
                      tokenFetchErrorCountRef.current++;

                      if (tokenFetchErrorCountRef.current === MAX_FAILED_TOKEN_REFRESHES) {
                        user.actions.clear();
                      }

                      callback(_context.t0, '');
                      setStateError(toErrorObject(_context.t0));

                    case 16:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee, null, [[2, 10]]);
            }))();
          },
          recover: function recover(lastConnectionDetails, callback) {
            /**
             * Only recover if the current path hasn't changed, start a
             * fresh connection if it has.
             */
            if (lastConnectionDetails.location === window.location.href) {
              // recover connection
              callback(true);
            } else {
              // do not recover connection
              callback(false);
            }
          }
        }); // Since we are storing the Ably client in a global variable, i.e. ablyClient, we need to force a re-render
        // to ensure that the client is properly returned in the hook.

        setAbly(ablyClient);
      });
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [tokenResponse, user.isAuthenticated]);
  return {
    ably: ably,
    error: stateError
  };
};